var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"disabled":!_vm.item.hasType,"preselect-first":true,"options":_vm.item.operatorOptions,"value":_vm.item.operator},on:{"input":_vm.updateOperator}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }